import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiCommunicationService } from './api-communication.service';
import { DivisionsContainer } from '../model/divisions-container.model';
import { Incident } from '../model/incident.model';
import { HeaderType } from '../model/header-type.enum';
import { AddressesContainerModel } from '../model/addresses-container.model';
import { LocationsContainerModel } from '../model/locations-container.model';

@Injectable({
  providedIn: 'root',
})

export class ReportsService {

  private createModeNotifier$: Subject<number> = new Subject<number>();
  private editModeNotifier$: Subject<string> = new Subject<string>();
  private editModeBySTMIDNotifier$: Subject<string> = new Subject<string>();
  private refreshGridNotifier$: Subject<boolean> = new Subject<boolean>();

  constructor(private apiCommunicationService: ApiCommunicationService) {
  }

  createReport(module: number): Observable<Incident> {
    return this.apiCommunicationService.createNewIncidentOrReport(HeaderType.REPORTS, module);
  }

  editReport(rowKey: string): Observable<Incident> {
    return this.apiCommunicationService.getExistingIncidentOrReport(HeaderType.REPORTS, rowKey);
  }

  editReportBySTMID(stmid: string): Observable<Incident> {
    return this.apiCommunicationService.getExistingIncidentOrReportBySTMID(HeaderType.REPORTS, stmid);
  }

  saveReport(model: Partial<Incident>): Observable<Incident> {
    return this.apiCommunicationService.saveIncidentOrReport(model);
  }

  cancelReport(stmid: string): Observable<boolean> {
    return this.apiCommunicationService.cancelIncidentOrReport(stmid);
  }

  createReference(parentRowKey: string, childRowKey: string): Observable<boolean> {
    return this.apiCommunicationService.createReference(parentRowKey, childRowKey);
  }

  getDivisions(): Observable<DivisionsContainer> {
    return this.apiCommunicationService.getDivisions();
  }

  getAddresses(): Observable<AddressesContainerModel> {
    return this.apiCommunicationService.getAddresses();
  }

  getLocations(division: number): Observable<LocationsContainerModel> {
    return this.apiCommunicationService.getLocations(division);
  }

  createReportNotify(division: number): void {
    this.createModeNotifier$.next(division);
  }

  getCreateModeNotification(): Observable<number> {
    return this.createModeNotifier$.asObservable();
  }

  editReportNotify(rowKey: string): void {
    this.editModeNotifier$.next(rowKey);
  }

  getEditModeNotification(): Observable<string> {
    return this.editModeNotifier$.asObservable();
  }

  editReportBySTMIDNotify(stmid: string): void {
    this.editModeBySTMIDNotifier$.next(stmid);
  }

  getEditModeBySTMIDNotification(): Observable<string> {
    return this.editModeBySTMIDNotifier$.asObservable();
  }

  refreshGridNotify(): void {
    this.refreshGridNotifier$.next(true);
  }

  getRefreshGridNotification(): Observable<boolean> {
    return this.refreshGridNotifier$.asObservable();
  }

}
